import { useParams, useNavigate } from "react-router-dom";

const useUrlParams = () => {
    const params = useParams();
    const navigate = useNavigate();
    const { mission_name, mission_id, scenario_id, tab_name, dashboard } = params;

    const navigate_home = () => {
        navigate(`${process.env.PUBLIC_URL}/`);
    };

    const navigate_back = () => {
        navigate(`${process.env.PUBLIC_URL}/${mission_name}/${mission_id}/simulate`);
    };

    const navigate_to = (tab: string) => {
        navigate(`${process.env.PUBLIC_URL}/${mission_name}/${mission_id}/generic_simulator/${scenario_id}/${tab}`);
    };

    return {
        mission_name,
        mission_id,
        scenario_id,
        tab_name,
        dashboard,
        navigate_home,
        navigate_back,
        navigate_to,
    };
};

export default useUrlParams;
